export const RAIL_WIDTH = 72;
export const RAIL_PAD = 8;
export const BAR_PAD_X = 6;

/* Mini-space layout constants (px) */
export const LINE_STEP = 2; // 1px text line + 1px gap
export const BLANK_H = LINE_STEP; // empty paragraph — one line of vertical space
export const BLOCK_GAP = 2; // between sibling blocks
export const CALLOUT_PAD = 2; // callout box padding around its content
export const HEADING_H = 2; // heading stroke
export const DIVIDER_H = 1;
export const SCENE_TOP_PAD = 4; // air above the icon, like the real page's top padding
export const DOC_ICON_SIZE = 5; // the doc's icon at the very top
export const DOC_TITLE_H = 2; // the doc's title stroke
export const MEDIA_SCALE = 0.06; // images keep a hint of their real size
export const MEDIA_MAX_H = 22;
